import { render, staticRenderFns } from "./LayoutContentTabNav.vue?vue&type=template&id=2043ce45&scoped=true&"
import script from "./LayoutContentTabNav.vue?vue&type=script&lang=js&"
export * from "./LayoutContentTabNav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContentTabNav.vue?vue&type=style&index=0&id=2043ce45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043ce45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VIcon,VImg,VOverlay})
